import { render, staticRenderFns } from "./BlockType101.vue?vue&type=template&id=bea0fba8&scoped=true"
import script from "./BlockType101.vue?vue&type=script&lang=ts"
export * from "./BlockType101.vue?vue&type=script&lang=ts"
import style0 from "./BlockType101.vue?vue&type=style&index=0&id=bea0fba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0fba8",
  null
  
)

export default component.exports